module.exports = __webpack_public_path__ + "static/media/Loading_2.b61b2b11.gif";